import {
  CultureInformation,
  CultureInformationJSON,
} from '../features/company/culture/dashboard/types/CultureInformationTypes';

export default class CultureInformationSerializer {
  static toObject(payload?: CultureInformationJSON): CultureInformation | undefined {
    if (!payload?.culture_information.culture_type) {
      return;
    }
    return {
      resourceId: payload.culture_information.resource_id,
      cultureType: {
        resourceId: payload.culture_information.culture_type.resource_id,
        imageUrl: payload.culture_information.culture_type.image_url,
        name: payload.culture_information.culture_type.name,
        description: {
          paragraphOne: {
            en: payload.culture_information.culture_type.description.paragraph_one.en,
            de: payload.culture_information.culture_type.description.paragraph_one.de,
          },
          paragraphTwo: {
            en: payload.culture_information.culture_type.description.paragraph_two.en,
            de: payload.culture_information.culture_type.description.paragraph_two.de,
          },
        },
        keywords: payload.culture_information.culture_type.keywords,
        teamValue: {
          htmlEn: payload.culture_information.culture_type?.team_value?.html_en || '',
          htmlDe: payload.culture_information.culture_type?.team_value?.html_de || '',
        },
      },
    };
  }

  static toJSON(cultureInformation: CultureInformation): CultureInformationJSON {
    return {
      culture_information: {
        resource_id: cultureInformation.resourceId || '',
        culture_type: {
          resource_id: cultureInformation.cultureType.resourceId,
          image_url: cultureInformation.cultureType.imageUrl,
          name: cultureInformation.cultureType.name,
          description: {
            paragraph_one: {
              en: cultureInformation.cultureType.description.paragraphOne.en,
              de: cultureInformation.cultureType.description.paragraphOne.de,
            },
            paragraph_two: {
              en: cultureInformation.cultureType.description.paragraphTwo.en,
              de: cultureInformation.cultureType.description.paragraphTwo.de,
            },
          },
          keywords: cultureInformation.cultureType.keywords,
          team_value: {
            html_en: cultureInformation.cultureType.teamValue?.htmlEn || '',
            html_de: cultureInformation.cultureType.teamValue?.htmlDe || '',
          },
        },
      },
    };
  }
}
